
import AdmTypography from "../Typography/Typography.vue";
import { defineComponent } from "vue";
import "./card.scss";

export default defineComponent({
  name: "adm-card-header",
  inheritAttrs: false,
  components: { AdmTypography },
  props: {
    title: {
      type: String,
      default: null,
    },
    subheader: {
      type: String,
      default: null,
    },
  },
});
